<form [formGroup]="languageSelectorForm" novalidate *transloco="let t">
	<prism-select
		id="sh-account-language-selected"
		formControlName="preferredLanguage"
		(valueChange)="setLocaleAndEmit(preferredLanguage.value)"
	>
		<prism-menu>
			@for (lang of languages; track lang.id) {
				<prism-menu-item [id]="'sh-preferred-language-option-' + lang.id" [value]="lang.id">
					{{ lang.name }}
				</prism-menu-item>
			}
		</prism-menu>

		<span slot="label" id="sh-account-language-label">
			{{ label }}
		</span>
	</prism-select>
	@if (
		languageSelectorForm.get('preferredLanguage')?.touched &&
		languageSelectorForm.get('preferredLanguage')?.hasError('required')
	) {
		<div class="prism-caption" id="sh-account-preferredLanguage-error-required-div">
			<span id="sh-account-preferredLanguage-error-required-span">
				{{ t('cloud.shared.error-labels.preferred-language-is-required') }}
			</span>
		</div>
	}
</form>
